import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';

// Scenes
import Entities from './scenes/Entities';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const Areas = (): React.ReactElement => (
    <ErrorBoundary namespace="Areas" FallbackComponent={<ErrorBoundaryAlert />}>
        <Helmet>
            <title>
                {'Areas - '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <Switch>
            <Redirect exact from="/organization/areas" to="/organization" />
            <Route
                exact
                path="/organization/areas/:entityTypeId"
                component={Entities}
            />
            <Redirect from="/organization/areas/*" to="/organization" />
        </Switch>
    </ErrorBoundary>
);

export default Areas;
